import { type FC } from 'react'
import { IntegrationServiceId } from '../../../common/integrations'
import { DelegatedEmailUpgradeBanner } from './IntegrationSpecificSettings/DelegatedEmail/DelegatedEmailUpgradeBanner'
import { DelegatedEmailCardBadge } from './IntegrationSpecificSettings/DelegatedEmail/DelegatedEmailCardBadge'

export const INTEGRATION_ROW_EXTRAS: Partial<Record<IntegrationServiceId, FC>> = {
  [IntegrationServiceId.DELEGATED_EMAIL]: DelegatedEmailUpgradeBanner,
}

export const INTEGRATION_CARD_BADGES: Partial<Record<IntegrationServiceId, FC>> = {
  [IntegrationServiceId.DELEGATED_EMAIL]: DelegatedEmailCardBadge,
}
